import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Laura', 'Carolina', 'Gabriela', 'Silvana', 'Patricia', 'Andrea', 'Valeria'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'San Miguel de Tucumán'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 8000);
    // Loop
    const interval = setInterval(() => {
      // Random interval between 8 and 15 seconds + 5 seconds display time
      const randomDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showNotification, randomDelay);
    }, 20000); // Base loop time
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed bottom-4 right-4 z-40 bg-white rounded-lg shadow-lg p-4 max-w-xs border-l-4 border-green-600 flex items-start gap-3" data-id="element-2">
          <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-3">
            <CheckCircle className="w-5 h-5 text-green-700" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm font-semibold text-gray-800" data-id="element-6">
              {notification.name} de {notification.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-7">
              acaba de comprar{' '}
              <span className="font-medium text-green-700" data-id="element-8">
                Herbolaria Esencial
              </span>
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-9">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}